import { text, TYPE_KEY_MAP, STATUS_KEY_MAP } from "../constants/translations";

/**
 * Returns translated label for a given escalation type.
 * @param {string} type  — raw backend value e.g. "ABUSIVE BEHAVIOUR"
 * @param {"en"|"ar"} language
 */
export const getTypeLabel = (type, language) => {
  if (!type) return "";
  const key = TYPE_KEY_MAP[type] || null;
  return key ? text[language]?.[key] || type : type;
};

/**
 * Returns translated label for a given status value.
 * @param {string} status   — raw backend value e.g. "IN_PROGRESS"
 * @param {"en"|"ar"} language
 */
export const getStatusLabel = (status, language) => {
  if (!status) return "";
  const key = STATUS_KEY_MAP[status] || null;
  return key
    ? text[language]?.[key] || status.replace(/_/g, " ")
    : status.replace(/_/g, " ");
};